import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {PrimerComponentLabelSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentLabel'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

const COPILOT_FEATURE_STATUS = z.lazy(() => z.enum(['Disabled', 'Enabled', 'Refresh', 'Unlimited']))

export type CopilotFeatureStatus = z.infer<typeof COPILOT_FEATURE_STATUS>

export const CopilotFeatureSchema = buildEntrySchemaFor('copilotFeature', {
  fields: z.lazy(() =>
    z.object({
      label: safeOptional(PrimerComponentLabelSchema),
      heading: RichTextSchema,
      subheading: safeOptional(RichTextSchema),
      statusForFree: COPILOT_FEATURE_STATUS,
      statusForPro: COPILOT_FEATURE_STATUS,
      statusForProPlus: COPILOT_FEATURE_STATUS,
      statusForMax: COPILOT_FEATURE_STATUS,
      statusForBusiness: COPILOT_FEATURE_STATUS,
      statusForEnterprise: COPILOT_FEATURE_STATUS,
      customTextForFree: safeOptional(RichTextSchema),
      customTextForPro: safeOptional(RichTextSchema),
      customTextForProPlus: safeOptional(RichTextSchema),
      customTextForMax: safeOptional(RichTextSchema),
      customTextForBusiness: safeOptional(RichTextSchema),
      customTextForEnterprise: safeOptional(RichTextSchema),
    }),
  ),
})

export type CopilotFeature = z.infer<typeof CopilotFeatureSchema>
